type ResultColor = {
  stroke: string;
  background: string;
  title: string;
}

export const RESULTS_COLORS: { [result: string]: ResultColor } = {
  'deliberator': {
    stroke: '#66C2A3',
    background: '#C6FFEB',
    title: '#01635F'
  },
  'incubator': {
    stroke: '#28BBB5',
    background: '#C2F9F5',
    title: '#01635F'
  },
  'strategizer': {
    stroke: '#007E8E',
    background: '#C5E6E9',
    title: '#015E6A'
  },
  'experimenter': {
    stroke: '#0FBCD2',
    background: '#C6F8FB',
    title: '#015E6A'
  },
  'pragmatist': {
    stroke: '#1D9FD9',
    background: '#C3F0FF',
    title: '#00608B'
  },
  'doer': {
    stroke: '#233682',
    background: '#CBD3EF',
    title: '#0D247F'
  },
  'explorer': {
    stroke: '#015CA7',
    background: '#CEDEEC',
    title: '#013967'
  },
  'distinguisher': {
    stroke: '#005E2C',
    background: '#CDF8E1',
    title: '#005A2A'
  },
  'detail-oriented': {
    stroke: '#019C4E',
    background: '#CDF8E1',
    title: '#005A2A'
  },
  'nuancer': {
    stroke: '#00AE8E',
    background: '#A0F5DA',
    title: '#015647'
  },
  'adaptor': {
    stroke: '#72BF44',
    background: '#E7FFC6',
    title: '#005A2A'
  },
  'insightful': {
    stroke: '#D8DF28',
    background: '#E7FFC6',
    title: '#005A2A'
  },
  'connector': {
    stroke: '#FFE600',
    background: '#FDF5AC',
    title: '#776C02'
  },
  'visionary': {
    stroke: '#F9C939',
    background: '#FDE9B0',
    title: '#9D5500'
  },
  'logical': {
    stroke: '#642D88',
    background: '#F4D8EC',
    title: '#642D88'
  },
  'realist': {
    stroke: '#CF118C',
    background: '#F4D8EC',
    title: '#BB077C'
  },
  'practical': {
    stroke: '#EA0E68',
    background: '#F4D8EC',
    title: '#C80253'
  },
  'fusionist': {
    stroke: '#EE2A25',
    background: '#FCD9D9',
    title: '#C30D09'
  },
  'brainstormer': {
    stroke: '#F3891E',
    background: '#FFDBBA',
    title: '#934A00'
  },
  'originator': {
    stroke: '#F1544D',
    background: '#FEEEED',
    title: '#BB4134'
  },
  'freethinker': {
    stroke: '#FAA819',
    background: '#FEDFAD',
    title: '#784C00'
  },
}